import request from '@/utils/request'

export default {
  // 登录
  login(data) {
    return request({
      url: 'login',
      method: 'post',
      data: data
    })
  },
  // 查看公司设置
  getcompanySet(data) {
    return request({
      url: 'companySet/select',
      method: 'post',
      data: data
    })
  },
  // 公司设置保存
  setcompanySet(data) {
    return request({
      url: 'companySet/preservationCompanySet',
      method: 'post',
      data: data
    })
  },
  // 查看网站设置
  getwebsiteSet(data) {
    return request({
      url: 'websiteSet/select',
      method: 'post',
      data: data
    })
  },
  // 网站设置保存
  setwebsiteSet(data) {
    return request({
      url: 'websiteSet/preservationWebsiteSet',
      method: 'post',
      data: data
    })
  },
  // 查看所有新闻
  getnews(data) {
    return request({
      url: 'news/select',
      method: 'post',
      data: data
    })
  },
  // 新建新闻
  insertnews(data) {
    return request({
      url: 'news/insert',
      method: 'post',
      data: data
    })
  },
  // 根据id查看新闻详情
  detailnews(data) {
    return request({
      url: 'news/selectOne?id=' + data,
      method: 'post',
    })
  },
  // 更新新闻
  updatenews(data) {
    return request({
      url: 'news/update',
      method: 'post',
      data: data
    })
  },
  // 删除新闻
  deletenews(data) {
    return request({
      url: 'news/delete?id=' + data,
      method: 'post',
    })
  },
  // 是否置顶新闻
  topnews(data) {
    return request({
      url: 'news/topOrNot?id=' + data,
      method: 'post',
    })
  },
  // 查看所有案例
  querySchemeCaseList(data) {
    return request({
      url: 'xy-scheme-case/querySchemeCaseList',
      method: 'post',
      data: data
    })
  },
  // 新建案例
  addSchemeCase(data) {
    return request({
      url: 'xy-scheme-case/addSchemeCase',
      method: 'post',
      data: data
    })
  },
  // 根据id查看案例详情
  querySchemeCaseDetail(data) {
    return request({
      url: 'xy-scheme-case/querySchemeCaseDetail',
      method: 'post',
      data: data
    })
  },
  // 更新案例
  editSchemeCase(data) {
    return request({
      url: 'xy-scheme-case/editSchemeCase',
      method: 'post',
      data: data
    })
  },
  // 删除案例
  deleteSchemeCase(data) {
    return request({
      url: 'xy-scheme-case/deleteSchemeCase',
      method: 'post',
      data: data
    })
  },
  // 是否置顶案例
  isUpSchemeCase(data) {
    return request({
      url: 'xy-scheme-case/isUpSchemeCase',
      method: 'post',
      data: data
    })
  },
  // 场景下拉列表
  queryHomeSceneList(data) {
    return request({
      url: 'xy-scene/queryHomeSceneList',
      method: 'post',
      data: data
    })
  },
  // 查看所有场景
  querySceneList(data) {
    return request({
      url: 'xy-scene/querySceneList',
      method: 'post',
      data: data
    })
  },
  // 新建场景
  addScene(data) {
    return request({
      url: 'xy-scene/addScene',
      method: 'post',
      data: data
    })
  },
  // 根据id查看场景详情
  querySceneDetail(data) {
    return request({
      url: 'xy-scene/querySceneDetail',
      method: 'post',
      data: data
    })
  },
  // 更新场景
  editScene(data) {
    return request({
      url: 'xy-scene/editScene',
      method: 'post',
      data: data
    })
  },
  // 删除场景
  deleteScene(data) {
    return request({
      url: 'xy-scene/deleteScene',
      method: 'post',
      data: data
    })
  },
  // 是否置顶场景
  isUpScene(data) {
    return request({
      url: 'xy-scene/isUpScene',
      method: 'post',
      data: data
    })
  },

  // 查询产品列表
  queryProductList(data) {
    return request({
      url: 'xy-product/queryProductList',
      method: 'post',
      data: data
    })
  },

  // 根据id查看产品详情
  detailProduct(data) {
    return request({
      url: 'xy-product/queryProductDetail',
      method: 'post',
      data: data
    })
  },

  // 删除产品
  deleteProductReq(data) {
    return request({
      url: 'xy-product/deleteProduct',
      method: 'post',
      data: data
    })
  },

  // 新增产品
  addProductReq(data) {
    return request({
      url: 'xy-product/addProduct',
      method: 'post',
      data: data
    })
  },

  // 编辑产品
  editProductReq(data) {
    return request({
      url: 'xy-product/editProduct',
      method: 'post',
      data: data
    })
  },

  //  查询方案列表
  querySchemeList(data) {
    return request({
      url: 'xy-scheme/querySchemeList',
      method: 'post',
      data: data
    })
  },

  // 删除方案
  deleteSchemeReq(data) {
    return request({
      url: 'xy-scheme/deleteScheme',
      method: 'post',
      data: data
    })
  },

  // 置顶方案
  isUpSchemeReq(data) {
    return request({
      url: 'xy-scheme/isUpScheme',
      method: 'post',
      data: data
    })
  },

  // 根据id查看方案详情
  detailScheme(data) {
    return request({
      url: 'xy-scheme/querySchemeDetail',
      method: 'post',
      data: data
    })
  },

  // 新增方案
  addSchemeReq(data) {
    return request({
      url: 'xy-scheme/addScheme',
      method: 'post',
      data: data
    })
  },

  // 编辑方案
  editSchemeReq(data) {
    return request({
      url: 'xy-scheme/editScheme',
      method: 'post',
      data: data
    })
  },


  //  官网
  //  关于我们
  selectNews(data) {
    return request({
      url: 'news/selectNews',
      method: 'post',
      data: data
    })
  },

  // 查询单个新闻
  newSelectOne(data) {
    return request({
      url: 'news/selectOne?id=' + data,
      method: 'post'
    })
  },

//  首页
//  查看产品与方案
  productsAndProgramsReq() {
    return request({
      url: 'homePage/productsAndPrograms',
      method: 'post'
    })
  },

  //  查看用户案例
  userStoriesReq() {
    return request({
      url: 'homePage/userStories',
      method: 'post'
    })
  },

  // 查看应用场景
  applicationScenarioReq() {
    return request({
      url: 'homePage/applicationScenario',
      method: 'post'
    })
  },

}
